import gql from "graphql-tag";
import { jobDetailsFields } from "../queries/getJob";

export const CLOSE_JOB = gql`
  mutation closeJob($jobId: ID!, $endedAt: Date) {
    closeJob(jobId: $jobId, endedAt: $endedAt) {
      ${jobDetailsFields}
    }
  }
`;
